module.exports = __webpack_public_path__ + "media/images/regions/causal_graphs/sub-saharan_africa-95cc3bd1ca95e7a62c530d6b07343c66.svg";